import React from 'react'
import { BannerFragment } from '@gql'
import { isNotNull } from '../../../utils/nonNull'
import { HomeBannerMask } from './homeBannerVideo/homeBannerMask'
import {
  Background,
  Heading,
  StyledButton,
  Subtext,
  TextContainer,
  Wrapper
} from './homeBannerVideo/styledHomeBanner'
import { HomeBannerVector } from "./homeBannerVideo/homeBannerVector";

export type BannerProps = {
  data: BannerFragment[]
}

export const Banner: React.VFC<BannerProps> = ({ data }) => {
  return (
    <Background>
      <Wrapper>
        {/* @ts-ignore */}
        {data?.[0]?.bannerImage?.[0]?.url && data?.[0]?.mobileImage?.[0]?.url && (
          <HomeBannerVector
            desktopVectorRight={data?.[0]?.desktopVectorRight ? data?.[0]?.desktopVectorRight?.[0]?.url : undefined}
            desktopVectorLeft={data?.[0]?.desktopVectorLeft ? data?.[0]?.desktopVectorLeft?.[0]?.url : undefined}
          >
            <HomeBannerMask
              src={isNotNull(data?.[0]?.bannerImage?.[0]?.url) ? data?.[0]?.bannerImage?.[0]?.url : ''}
              //@ts-ignore
              mobileSrc={isNotNull(data?.[0]?.mobileImage?.[0]?.url) ? data?.[0]?.mobileImage?.[0]?.url : ''}
              videoId={data?.[0]?.bannerVideo ? data?.[0]?.bannerVideo : undefined}
              desktopVectorRight={data?.[0]?.desktopVectorRight ? data?.[0]?.desktopVectorRight?.[0]?.url : undefined}
              mobileVector={data?.[0]?.mobileVector ? data?.[0]?.mobileVector?.[0]?.url : undefined}
            >
              <TextContainer>
                {data?.[0]?.bannerText && (
                  //@ts-ignore
                  <Heading $largeFont={data?.[0]?.textSize} variant="h2" component={'h1'}>{data?.[0]?.bannerText}</Heading>
                )}
                {data?.[0]?.bannerSubText && (
                  <Subtext $largeFont={data[0].textSize}>{data?.[0]?.bannerSubText}</Subtext>
                )}
                {data?.[0]?.bannerButtonField?.url && (
                  <StyledButton $largeFont={data[0].textSize} className="primary-banner-btn" cta href={data?.[0]?.bannerButtonField?.url}>{data?.[0]?.bannerButtonField?.customText}</StyledButton>
                )}
              </TextContainer>
            </HomeBannerMask>
          </HomeBannerVector>
        )}
      </Wrapper>
    </Background>
  )
}
